import React from "react";
import { SvgIcon } from "@mui/material";
import { SvgIconsProps } from "~/common";

export const HeadPhones = (props: SvgIconsProps) => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.3333 25.3334C29.3333 27.5387 27.5386 29.3334 25.3333 29.3334H24C21.7946 29.3334 20 27.5387 20 25.3334V21.3334C20 19.1281 21.7946 17.3334 24 17.3334H26.6666V16.0001C26.6666 10.1187 21.8813 5.33341 16 5.33341C10.1186 5.33341 5.33329 10.1187 5.33329 16.0001V17.3334H7.99996C10.2053 17.3334 12 19.1281 12 21.3334V25.3334C12 27.5387 10.2053 29.3334 7.99996 29.3334H6.66663C4.46129 29.3334 2.66663 27.5387 2.66663 25.3334V16.0001C2.66663 8.64808 8.64796 2.66675 16 2.66675C23.352 2.66675 29.3333 8.64808 29.3333 16.0001V25.3334ZM5.33329 25.3334C5.33329 26.0694 5.93196 26.6667 6.66663 26.6667H7.99996C8.73463 26.6667 9.33329 26.0694 9.33329 25.3334V21.3334C9.33329 20.5974 8.73463 20.0001 7.99996 20.0001H5.33329V25.3334ZM26.6666 20.0001H24C23.264 20.0001 22.6666 20.5974 22.6666 21.3334V25.3334C22.6666 26.0694 23.264 26.6667 24 26.6667H25.3333C26.0693 26.6667 26.6666 26.0694 26.6666 25.3334V20.0001Z"
        fill="#008769"
      />
    </SvgIcon>
  );
};
